var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-1214 -542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(1223 479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M24.541,76H2.365A2.368,2.368,0,0,0,0,78.365V92.554a2.368,2.368,0,0,0,2.365,2.365H24.541a2.368,2.368,0,0,0,2.365-2.365V78.365A2.367,2.367,0,0,0,24.541,76Zm-.331,1.577-9.085,9.037a2.365,2.365,0,0,1-3.346,0L2.7,77.577ZM1.577,92.233V78.687l6.813,6.777ZM2.7,93.342l6.81-6.767,1.159,1.153a3.941,3.941,0,0,0,5.572,0L17.4,86.575l6.81,6.767ZM25.33,92.233l-6.813-6.769,6.813-6.777Z",
    transform: "translate(0 -76)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.db794300ec042bc7b96cec91d5a63b84.svg";
export { ForwardRef as ReactComponent };